module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1b_Image13e.bf5b4cdd.jpg";